import { loginPlatform } from "../../../api/adminConsoleAuth";
import { PLATFORM_BEARER_KEY } from "../../../api/http";

const PLATFORM_AUTH_KEY = "platform_admin_auth";

export const platformAuth = {
  async login(password: string): Promise<boolean> {
    try {
      const res = await loginPlatform(password);
      if (!res?.accessToken) return false;
      sessionStorage.setItem(PLATFORM_BEARER_KEY, res.accessToken);
      sessionStorage.setItem(PLATFORM_AUTH_KEY, "true");
      return true;
    } catch {
      return false;
    }
  },
  logout() {
    sessionStorage.removeItem(PLATFORM_AUTH_KEY);
    sessionStorage.removeItem(PLATFORM_BEARER_KEY);
  },
  isLoggedIn(): boolean {
    return !!sessionStorage.getItem(PLATFORM_BEARER_KEY);
  },
};
